import Card from "../../cards/card";

export class CardDeck {
  /**
   * @param scene {GameScene}
   * @param table {Table}
   * @param cardsLength {number}
   * @param seat {Seat}
   */
  constructor(scene, table, cardsLength, seat) {
    // super(scene, 0, 0, scene.atlasTexture, '2-card-deck');
    this.scene = scene;
    this.table = table;
    this.seat = seat;
    // this.scene.add.existing(this);
    this.cardsList = [];
    this.children = [];
    this.cardsScaleX = 0;
    this.cardsLength = cardsLength;
    for (let i = 0; i < this.cardsLength; i++) {
      this.cardsList.push(new Card(this.scene, this.table));
      this.children.push(this.cardsList[i]);
      this.children.push(this.cardsList[i].upsideDown);
    }

    this.cards = []; /* cards object from server */
    this.dealTweens = [];
    this.allowGetCardFromDealer = true;
    this.showHandOnFoldPermission = true;
    this.hasHandShown = false;
    this.cardsY = 0;
  }

  visibilityControls(visibility) {
    this.cardsList.forEach((card) => {
      card.visibilityControls(visibility);
    });
    if (visibility) {
      if (
        this.cardsList[0].upsideDown.angle === 0 &&
        !this.cardsList.find((card) => card.isDealing === true)
      )
        this.arrangeCards();
    }
  }

  handVisibilityControls(visibility) {
    if (this.cardsList.find((card) => card.isDealing === true) && visibility)
      return;
    if (visibility) this.visibilityControls(false);
    this.allowGetCardFromDealer = true;
    this.cardsList.forEach((card) => {
      if (!visibility) {
        // if (this.table.gameState?.src !== "showhand") {
        if (!this.seat.playerInfo?.showHand) {
          if (card.visible) card.setVisible(false);
        }
      } else {
        if (this.seat.playerInfo?.hand.length > 0 && !card.visible)
          card.setVisible(true);
      }
    });
    this.hasHandShown = visibility;
  }

  setDisable(status) {
    // if (status) return;
    if (
      this.table.gameState?.src === "showhand" ||
      this.table.gameState?.state === "End"
    )
      return;
    this.cardsList.forEach((card) => {
      const beforeWinY = card.getData("showCardY");
      if (beforeWinY && beforeWinY !== card.y) {
        card.y = beforeWinY;
        // card.beforeWinY = undefined;
      }
      const beforeWinX = card.getData("showCardX");
      if (beforeWinX && beforeWinX !== card.x) {
        card.x = beforeWinX;
      }
      const showCardAngle = card.getData("showCardAngle");
      if (showCardAngle && showCardAngle !== card.angle) {
        card.angle = showCardAngle;
      }
      // if(card.angle != 0) card.angle = 0;
      // card.clearTint();
    });
  }

  /**
   * @param dealerX {number}
   * @param dealerY {number}
   * @param cardIndex {number}
   * @param delay {number}
   * @param scale {number}
   * @param isMyTable {boolean}
   * @return {Promise<unknown>}
   */
  async getCardFromDealer(
    dealerX,
    dealerY,
    cardIndex,
    delay,
    scale,
    isMyTable
  ) {
    const card = this.cardsList[cardIndex];
    if (this.allowGetCardFromDealer) {
      return new Promise((resolve) => {
        // this.upsideDownCards[cardIndex].setPosition(dealerX , dealerY).setAngle(0);
        card.upsideDown.setPosition(dealerX, dealerY).setAngle(0);
        // if(scale) this.upsideDownCards[cardIndex].setScale(scale);
        if (scale) card.upsideDown.setScale(scale);
        if (this.scene.tweenEnable) {
          // this.cardIsDealing[cardIndex] = true;
          card.isDealing = true;
          this.dealTweens.push(
            this.scene.tweens.add({
              // targets: this.upsideDownCards[cardIndex],
              targets: card.upsideDown,
              delay: delay + 100,
              // duration: 100,
              duration: 500,
              x: card.upsideDown.getData("initX"),
              y: card.upsideDown.getData("initY"),
              scale: card.upsideDown.getData("initScale"),
              ease: "Linear",
              alpha: 1,
              onComplete: () => {
                card.isDealing = false;
                card.upsideDown.setAlpha(1);
                if (
                  card.visible ||
                  this.seat.playerInfo.lastAction === "Fold" ||
                  this.seat.playerInfo.state === "SitOut" ||
                  this.seat.playerInfo.state === "WaitToJoin" ||
                  this.seat.playerInfo.state === "WaitToStart"
                ) {
                  if (card.upsideDown.visible)
                    card.upsideDown.setVisible(false);
                }
                if (cardIndex === this.cardsLength - 1) {
                  if (!isMyTable && card.upsideDown.angle === 0) {
                    this.arrangeCards();
                  }
                  this.clearCards();
                }
                resolve("completed");
              },
              onStart: () => {
                card.upsideDown.setAlpha(0);
                if (!card.upsideDown.visible) card.upsideDown.setVisible(true);
                this.table.sounds.play("deal");
              },
            })
          );
        } else {
          if (!card.upsideDown.visible) card.upsideDown.setVisible(true);
          card.upsideDown.setPosition(
            card.upsideDown.getData("initX"),
            card.upsideDown.getData("initY")
          );
          card.upsideDown.setScale(card.upsideDown.getData("initScale"));
          if (cardIndex === this.cardsLength - 1) {
            if (!isMyTable && card.upsideDown.angle === 0) {
              this.arrangeCards();
            }
            this.clearCards();
          }
          resolve("completed");
        }
      });
    }
  }

  arrangeCards() {
    // const initAngle = ["lb2","lb1","lt1","lt2"].includes(this.seat.position) ? - this.cardsLength * 5 : 0;
    for (let i = 0; i < this.cardsList.length; i++) {
      const card = this.cardsList[i];
      if (this.scene.tweenEnable && card.isDealing === false) {
        this.scene.tweens.add({
          targets: card.upsideDown,
          duration: 200,
          y: {
            getEnd: () => {
              return card.upsideDown.getData("arrangedY");
            },
          },
          x: {
            getEnd: () => {
              return card.upsideDown.getData("arrangedX");
            },
          },
          scale: {
            getEnd: () => {
              return card.upsideDown.getData("arrangedScale");
            },
          },
          angle: {
            getEnd: () => {
              return card.upsideDown.getData("arrangedAngle");
            },
          },
          ease: "Linear",
          onComplete: () => {
            card.upsideDown.y = card.upsideDown.getData("arrangedY");
            card.upsideDown.x = card.upsideDown.getData("arrangedX");
            card.upsideDown.scale = card.upsideDown.getData("arrangedScale");
            card.upsideDown.angle = card.upsideDown.getData("arrangedAngle");
          },
        });
      } else {
        card.upsideDown.angle = card.upsideDown.getData("arrangedAngle");
        card.upsideDown.y = card.upsideDown.getData("arrangedY");
        card.upsideDown.x = card.upsideDown.getData("arrangedX");
        card.upsideDown.scale = card.upsideDown.getData("arrangedScale");
      }
    }
  }
  arrangeShowCards(i) {
    // for (let i = 0; i < this.cardsList.length; i++) {
    const card = this.cardsList[i];
    card.getData("showCardY");
    if (this.scene.tweenEnable && card.isDealing === false) {
      this.scene.tweens.add({
        targets: card,
        duration: 200,
        y: {
          getEnd: () => {
            return card.getData("showCardY");
          },
        },
        x: {
          getEnd: () => {
            return card.getData("showCardX");
          },
        },
        angle: card.getData("showCardAngle"),
        ease: "Linear",
        onComplete: () => {
          card.y = card.getData("showCardY");
          card.x = card.getData("showCardX");
          card.angle = card.getData("showCardAngle");
        },
      });
    } else {
      card.angle = card.getData("showCardAngle");
      card.y = card.getData("showCardY");
      card.x = card.getData("showCardX");
    }
    // }
  }

  clearCards() {
    this.cards = [];
  }

  unArrangeCards() {
    this.cardsList.forEach((card) => {
      card.upsideDown.setAngle(0);
    });
  }

  handsUpdate(cards) {
    let kickerCard = false;
    for (let i = 0; i < cards.length; i++) {
      if (
        this.table.gameState.state === "End" &&
        !this.seat.playerInfo.showHandButton &&
        !(
          this.seat.playerInfo &&
          this.seat.playerInfo.win > 0 &&
          this.seat.playerInfo.bestHand?.hand.find(
            (c) => c.code === cards[i].code
          )
        )
      ) {
        kickerCard = true;
      } else {
        kickerCard = false;
      }
      this.cardsList[i].updateTexture(cards[i].code, kickerCard);
    }
  }

  showHand(cards, byPlayer) {
    let kickerCard = false;
    if (byPlayer) {
      this.handsUpdate(this.cards);
      for (let i = 0; i < cards.length; i++) {
        const targetCard = this.cardsList.find((card) => card.code === cards[i].code);
        if (!targetCard.visible && this.scene.tweenEnable) {
          targetCard.scaleX = 0;
          targetCard.setVisible(true);
          this.scene.tweens.add({
            targets: targetCard,
            scaleX: this.cardsScaleX,
            ease: "Linear",
            duration: 300,
            // onComplete: () => {
            // if (targetCard.overlay.visible) targetCard.overlay.setVisible(false);
            // },
          });
        }
        // this.cardsList[i].updateTexture(this.cards[i].code);
        // this.cardsList[i].scaleX = 0;
        // this.cardsList[i].setVisible(true);
        // if (this.scene.tweenEnable) {
        //   this.scene.tweens.add({
        //     targets: [...this.cardsList],
        //     scaleX: this.cardsScaleX,
        //     ease: "Linear",
        //     duration: 300,
        //   });
        // } else {
        //   Phaser.Actions.SetScaleX(this.cardsList, this.cardsScaleX);
        // }
      }
    } else {
      if (this.hasHandShown) return;
      this.allowGetCardFromDealer = false;
      if (
        !this.cards.length ||
        (this.cards.length && this.cards.length < this.cardsList.length)
      ) {
        // if (cards.length > 0) {
        // if(this.dealTween.isSeeking) this.dealTween.seek(1);
        // this.dealTweens.forEach(tween => tween.complete());
        // this.visibilityControls(false);
        // this.dealTweens = [];
        // }
        if (cards) {
          for (let i = 0; i < cards.length; i++) {
            // FIXME:(sentry) undefined is not an object (evaluating 'this.cardsList[e].updateTexture')
            if (
              this.table.gameState.state === "End" &&
              !this.seat.playerInfo.showHandButton &&
              !(
                this.seat.playerInfo &&
                this.seat.playerInfo.win > 0 &&
                this.seat.playerInfo.bestHand?.hand.find(
                  (c) => c.code === cards[i].code
                )
              )
            ) {
              kickerCard = true;
            } else {
              kickerCard = false;
            }
            const card = this.cardsList[i];
            card.updateTexture(cards[i].code, kickerCard);
            card.scaleX = 0;
            if (!card.visible) card.setVisible(true);
            if (this.scene.tweenEnable) {
              this.scene.tweens.add({
                targets: card,
                scaleX: this.cardsScaleX,
                ease: "Linear",
                duration: 400,
                delay: this.isMyTable ? 50 * i : 0,
                onComplete: () => {
                  card.scaleX = this.cardsScaleX;
                  this.arrangeShowCards(i);
                },
                onStart: () => {
                  card.upsideDown.setVisible(false);
                },
              });
              // this.scene.tweens.add({
              //   targets: card.upsideDown,
              //   scaleX: 0,
              //   ease: "Linear",
              //   duration: 300,
              //   delay: 100 * i,
              //   onComplete: () => {
              //     card.upsideDown.scaleX = this.cardsScaleX;
              //     // if(card.upsideDown.angle !== 0) card.upsideDown.setAngle(0);
              //     card.upsideDown.setVisible(false);
              //   },
              //   onStart:()=>{
              //     // if(card.upsideDown.visible && this.isMyTable){
              //       // card.upsideDown.setAngle(card.getData("showCardAngle"));
              //       // card.upsideDown.setX(card.getData("showCardX"));
              //       // card.upsideDown.setY(card.getData("showCardY"));
              //     // }
              //   }
              // });
            } else {
              card.scaleX = this.cardsScaleX;
              card.upsideDown.scaleX = this.cardsScaleX;
              this.arrangeShowCards(i);
              card.upsideDown.setVisible(false);
            }
          }
        }
      } else {
        this.handVisibilityControls(true);
        this.visibilityControls(false);
      }
      this.hasHandShown = true;
      this.cards = cards;
    }
  }
  showACard(cardCode) {
    let theCard = this.cardsList.find((card) => card.code === cardCode);
    // this.cardsList[i].setTexture(
    //   "cards",
    //   Helpers.getCardsFrameByCode(this.cards[i].code)
    // );
    theCard.scaleX = 0;
    if (!theCard.visible) theCard.setVisible(true);
    if (theCard.y !== this.beforeWinY) {
    }
    if (this.scene.tweenEnable) {
      this.scene.tweens.add({
        targets: theCard,
        scaleX: this.cardsScaleX,
        ease: "Linear",
        duration: 300,
      });
    } else {
      Phaser.Actions.SetScaleX(this.cardsList, this.cardsScaleX);
    }
  }
  tossACard(cardCode) {
    let theCard = this.cardsList.find((card) => card.code === cardCode);
    let theCardIndex = this.cardsList.findIndex(
      (card) => card.code === cardCode
    );

    const box = this.seat.box;
    // box.setVisible(false);
    // if (theCard.overlay.visible) theCard.overlay.visible = false;
    // theCard = this.cardsList[this.tossACardCounter];
    theCard.hideCardOverlay();
    if (this.scene.tweenEnable) {
      let tweens = [];
      if (!theCard.visible) {
        theCard.y = box.y;
        theCard.setVisible(true);
        tweens.push({
          ease: "Linear",
          duration: 150,
          y: theCard.beforeWinY,
          onComplete: () => {
            theCard.y = theCard.beforeWinY;
          },
        });
      }
      tweens.push({
        ease: "Linear",
        duration: 100,
        angle: -25,
        onComplete: () => {
          theCard.angle = -25;
        },
      });
      tweens.push({
        delay: 150,
        ease: "Linear",
        duration: 50,
        x:
          box.x +
          box.displayWidth * 0.4 +
          (theCardIndex * box.displayWidth) / 6,
        y:
          box.y -
          box.displayHeight * 1.7 +
          (theCardIndex * box.displayHeight) / 8,
        angle: (theCardIndex + 1) * 12,
      });

      const chain = this.scene.tweens.chain({
        targets: theCard,
        tweens: tweens,
        onComplete: () => {
          theCard.x =
            box.x +
            box.displayWidth * 0.4 +
            (theCardIndex * box.displayWidth) / 6;
          theCard.y =
            box.y -
            box.displayHeight * 1.7 +
            (theCardIndex * box.displayHeight) / 8;
          chain.destroy();
        },
      });
      // timeLine.play();
    }
  }

  showHandOnFold() {
    if (this.cardsList[0].visible) return;
    if (this.scene.tweenEnable) {
      const selfPlayer = this.seat.playerInfo;
      const alreadyShownCards = selfPlayer.showHandCards;
      this.handsUpdate(selfPlayer.hand);
      this.cardsList.forEach((card) => {
        if (alreadyShownCards.find((c) => c.code === card.code)) return;
        card.setY(this.cardsY);
        card.setY(card.y + this.cardsList[0].displayHeight / 2);
        card.setAlpha(0);
        if (!card.visible) card.setVisible(true);
        this.scene.tweens.add({
          targets: card,
          duration: 100,
          // y: `-=${this.cardsList[0].displayHeight / 2}`,
          y: card.getData("showCardY"),
          alpha: 1,
          ease: "Linear",
          onComplete: () => {},
        });
      });

      // Phaser.Actions.SetY(this.cardsList, this.cardsY);
      // Phaser.Actions.IncY(this.cardsList, this.cardsList[0].displayHeight / 2);
      // Phaser.Actions.SetAlpha(this.cardsList, 0);
      // Phaser.Actions.SetVisible(this.cardsList, true);
      // this.scene.tweens.add({
      //   targets: this.cardsList,
      //   duration: 100,
      //   y: `-=${this.cardsList[0].displayHeight / 2}`,
      //   alpha: 1,
      //   ease: "Linear",
      //   onComplete: () => {},
      // });
    }
  }

  hideHandOnFold() {
    if (!this.cardsList[0].visible) return;
    const selfPlayer = this.seat.playerInfo;
    const alreadyShownCards = selfPlayer.showHandCards;
    this.cardsList.forEach((card) => {
      if (this.scene.tweenEnable) {
        if (alreadyShownCards.find((c) => c.code === card.code)) return;
        this.scene.tweens.add({
          targets: card,
          // delay: 400,
          duration: 100,
          y: `+=${this.cardsList[0].displayHeight / 2}`,
          ease: "Linear",
          alpha: 0,
          onComplete: () => {
            if (card.visible) card.setVisible(false);
            card.setY(this.cardsY);
            card.setAlpha(1);
          },
        });
      } else {
        if (card.visible) card.setVisible(false);
      }
    });

    // this.scene.tweens.add({
    //   targets: this.cardsList,
    //   // delay: 400,
    //   duration: 100,
    //   y: `+=${this.cardsList[0].displayHeight / 2}`,
    //   ease: "Linear",
    //   alpha: 0,
    //   onComplete: () => {
    //     Phaser.Actions.SetVisible(this.cardsList, false);
    //     Phaser.Actions.SetY(this.cardsList, this.cardsY);
    //     Phaser.Actions.SetAlpha(this.cardsList, 1);
    //   },
    // });
  }

  // handleVisibilityChange(hidden) {
  //   console.log("handleVisibilityChange");
  //   let activeTweensUpsideDownCards, activeTweensCardsList;
  //   if (hidden) {
  //     /* agar game hidden shod va active tween dashtim bayad hame ra foran b payan bbarim
  //      * ba tavajoh b inke agr tweeni k montazer etmam delay ast ra seek konim onStart on tween ejra nemishavad
  //      */
  //     activeTweensUpsideDownCards = this.scene.tweens.getTweensOf(
  //       this.upsideDownCards
  //     );
  //     activeTweensUpsideDownCards.forEach((tween) => {
  //       tween.targets.forEach((t) => t.setVisible(true));
  //       tween.seek(1);
  //       // if(tween.callbacks.onComplete){
  //       //     tween.complete(tween.elapsed);
  //       // }
  //     });
  //     activeTweensCardsList = this.scene.tweens.getTweensOf(this.cardsList);
  //     activeTweensCardsList.forEach((tween) => {
  //       tween.seek(1);
  //     });
  //   }
  // }

  /***
   * @param width {number} width of seat box
   * @param height {number} width of seat box
   * @param initX {number} seat box top left x
   * @param initY {number} seat box top left y
   */
  positionControls(width, height, initX, initY) {
    const cardSize = width / 1.5;
    let cardWidth = 0;
    for (let i = 0; i < this.cardsList.length; i++) {
      const card = this.cardsList[i];
      card.scaleControls(cardSize);
      if (i === 0) {
        cardWidth = card.displayWidth * 0.85;
        this.cardsScaleX = card.scaleX;
      }
      card.setPosition(
        initX +
          (-(cardWidth / 2.6) * (this.cardsLength - 1)) / 2 +
          (i * cardWidth) / 2.6,
        initY - card.displayHeight * 0.6
      );
      card.positionControls();
      card.upsideDown.setData("arrangedScale", card.scale * 0.6);
      if (this.cardsLength === 4) {
        card.upsideDown.setData(
          "arrangedAngle",
          i == 0 ? -20 : i == 1 ? -10 : i == 2 ? 0 : 10
        );
        switch (i) {
          case 0: {
            card.upsideDown.setData(
              "arrangedY",
              card.upsideDown.y + cardWidth * 0.04
            );
            card.setData("showCardY", card.y + card.displayWidth * 0.0625);
            card.setData("showCardAngle", -40);
            break;
          }
          case 1: {
            card.upsideDown.setData("arrangedY", card.upsideDown.y);
            card.setData("showCardY", card.y - card.displayWidth * 0.063);
            card.setData("showCardAngle", -20);
            break;
          }
          case 2: {
            card.upsideDown.setData("arrangedY", card.upsideDown.y);
            card.setData("showCardY", card.y - card.displayWidth * 0.03);
            card.setData("showCardAngle", 7);
            break;
          }
          case 3: {
            card.upsideDown.setData(
              "arrangedY",
              card.upsideDown.y + cardWidth * 0.05
            );
            card.setData("showCardY", card.y + card.displayWidth * 0.15);
            card.setData("showCardAngle", 30);
            break;
          }
        }
        card.setData("showCardX", card.x - ((i - 2) * card.displayWidth) / 30);
        if (["lb2", "lb1", "lt1", "lt2", "ct"].includes(this.seat.position)) {
          card.upsideDown.setData(
            "arrangedX",
            card.upsideDown.x -
              cardWidth * 0.2 -
              (i * card.upsideDown.displayWidth) / 5
          );
        } else {
          card.upsideDown.setData(
            "arrangedX",
            card.upsideDown.x +
              cardWidth * 0.1 -
              ((i - this.cardsList.length + 1) * card.upsideDown.displayWidth) /
                5
          );
        }
      } else if (this.cardsLength === 5) {
        card.upsideDown.setData(
          "arrangedAngle",
          i == 0 ? -30 : i == 1 ? -20 : i == 2 ? -10 : i == 3 ? 3 : 10
        );
        switch (i) {
          case 0: {
            card.upsideDown.setData(
              "arrangedY",
              card.upsideDown.y + cardWidth * 0.15
            );
            card.setData("showCardY", card.y + card.displayWidth * 0.0625);
            card.setData("showCardAngle", -40);
            break;
          }
          case 1: {
            card.upsideDown.setData(
              "arrangedY",
              card.upsideDown.y + cardWidth * 0.05
            );
            card.setData("showCardY", card.y - card.displayWidth * 0.063);
            card.setData("showCardAngle", -30);
            break;
          }
          case 2: {
            card.upsideDown.setData("arrangedY", card.upsideDown.y);
            card.setData("showCardY", card.y - card.displayWidth * 0.1);
            card.setData("showCardAngle", -10);
            break;
          }
          case 3: {
            card.upsideDown.setData("arrangedY", card.upsideDown.y);
            card.setData("showCardY", card.y - card.displayWidth * 0.05);
            card.setData("showCardAngle", 7);
            break;
          }
          case 4: {
            card.upsideDown.setData(
              "arrangedY",
              card.upsideDown.y + cardWidth * 0.05
            );
            card.setData("showCardY", card.y + card.displayWidth * 0.1);
            card.setData("showCardAngle", 30);
            break;
          }
        }
        card.setData("showCardX", card.x - ((i - 2) * card.displayWidth) / 25);
        if (["lb2", "lb1", "lt1", "lt2", "ct"].includes(this.seat.position)) {
          card.upsideDown.setData(
            "arrangedX",
            card.upsideDown.x -
              cardWidth * 0.2 -
              (i * card.upsideDown.displayWidth) / 5
          );
        } else {
          card.upsideDown.setData(
            "arrangedX",
            card.upsideDown.x -
              ((i - this.cardsList.length + 1) * card.upsideDown.displayWidth) /
                5
          );
        }
      } else if (this.cardsLength === 2) {
        card.upsideDown.setData("arrangedAngle", i === 0 ? -10 : 3);
        card.upsideDown.setData("arrangedY", card.upsideDown.y);
        if (["lb2", "lb1", "lt1", "lt2", "ct"].includes(this.seat.position)) {
          card.upsideDown.setData(
            "arrangedX",
            card.upsideDown.x -
              cardWidth * 0.45 -
              (i * card.upsideDown.displayWidth) / 5
          );
        } else {
          card.upsideDown.setData(
            "arrangedX",
            card.upsideDown.x +
              cardWidth * 0.25 -
              ((i - this.cardsList.length + 1) * card.upsideDown.displayWidth) /
                5
          );
        }
        card.setData("showCardY", card.y);
        card.setData(
          "showCardX",
          i === 0
            ? card.x - card.displayWidth * 0.09
            : card.x + card.displayWidth * 0.09
        );
        card.setData("showCardAngle", i === 0 ? -10 : 5);
      }
      card.beforeWinY = card.getData("showCardY");
      card.beforeWinX = card.getData("showCardX");
    }
    this.cardsY = this.cardsList[0].y;
  }
  /***
   * @param width {number} width of seat box
   * @param height {number} width of seat box
   * @param initX {number} seat box top left x
   * @param initY {number} seat box top left y
   */
  reposition(width, height, initX, initY) {
    let cardWidth = 0;
    for (let i = 0; i < this.cardsList.length; i++) {
      const card = this.cardsList[i];
      if (i === 0) {
        cardWidth = card.displayWidth * 0.85;
      }
      card.setPosition(
        initX +
          (-(cardWidth / 2.6) * (this.cardsLength - 1)) / 2 +
          (i * cardWidth) / 2.6,
        initY - card.displayHeight * 0.6
      );
      card.reposition();
      // card.beforeWinY = card.y;
      // card.beforeWinX = card.x;
      card.upsideDown.setData("arrangedScale", card.scale * 0.6);
      if (this.cardsLength === 4) {
        switch (i) {
          case 0: {
            card.upsideDown.setData(
              "arrangedY",
              card.upsideDown.y + cardWidth * 0.04
            );
            card.setData("showCardY", card.y + card.displayWidth * 0.0625);
            break;
          }
          case 1: {
            card.upsideDown.setData("arrangedY", card.upsideDown.y);
            card.setData("showCardY", card.y - card.displayWidth * 0.063);
            break;
          }
          case 2: {
            card.upsideDown.setData("arrangedY", card.upsideDown.y);
            card.setData("showCardY", card.y - card.displayWidth * 0.03);
            break;
          }
          case 3: {
            card.upsideDown.setData(
              "arrangedY",
              card.upsideDown.y + cardWidth * 0.05
            );
            card.setData("showCardY", card.y + card.displayWidth * 0.15);
            break;
          }
        }
        card.setData("showCardX", card.x - ((i - 2) * card.displayWidth) / 30);
        if (["lb2", "lb1", "lt1", "lt2", "ct"].includes(this.seat.position)) {
          card.upsideDown.setData(
            "arrangedX",
            card.upsideDown.x -
              cardWidth * 0.2 -
              (i * card.upsideDown.displayWidth) / 5
          );
        } else {
          card.upsideDown.setData(
            "arrangedX",
            card.upsideDown.x +
              cardWidth * 0.1 -
              ((i - this.cardsList.length + 1) * card.upsideDown.displayWidth) /
                5
          );
        }
      } else if (this.cardsLength === 5) {
        switch (i) {
          case 0: {
            card.upsideDown.setData(
              "arrangedY",
              card.upsideDown.y + cardWidth * 0.15
            );
            card.setData("showCardY", card.y + card.displayWidth * 0.0625);
            break;
          }
          case 1: {
            card.upsideDown.setData(
              "arrangedY",
              card.upsideDown.y + cardWidth * 0.05
            );
            card.setData("showCardY", card.y - card.displayWidth * 0.063);
            break;
          }
          case 2: {
            card.upsideDown.setData("arrangedY", card.upsideDown.y);
            card.setData("showCardY", card.y - card.displayWidth * 0.1);
            break;
          }
          case 3: {
            card.upsideDown.setData("arrangedY", card.upsideDown.y);
            card.setData("showCardY", card.y - card.displayWidth * 0.05);
            break;
          }
          case 4: {
            card.upsideDown.setData(
              "arrangedY",
              card.upsideDown.y + cardWidth * 0.05
            );
            card.setData("showCardY", card.y + card.displayWidth * 0.1);
            break;
          }
        }
        card.setData("showCardX", card.x - ((i - 2) * card.displayWidth) / 25);
        if (["lb2", "lb1", "lt1", "lt2", "ct"].includes(this.seat.position)) {
          card.upsideDown.setData(
            "arrangedX",
            card.upsideDown.x -
              cardWidth * 0.2 -
              (i * card.upsideDown.displayWidth) / 5
          );
        } else {
          card.upsideDown.setData(
            "arrangedX",
            card.upsideDown.x -
              ((i - this.cardsList.length + 1) * card.upsideDown.displayWidth) /
                5
          );
        }
      } else if (this.cardsLength === 2) {
        card.upsideDown.setData("arrangedY", card.upsideDown.y);
        if (["lb2", "lb1", "lt1", "lt2", "ct"].includes(this.seat.position)) {
          card.upsideDown.setData(
            "arrangedX",
            card.upsideDown.x -
              cardWidth * 0.45 -
              (i * card.upsideDown.displayWidth) / 5
          );
        } else {
          card.upsideDown.setData(
            "arrangedX",
            card.upsideDown.x +
              cardWidth * 0.25 -
              ((i - this.cardsList.length + 1) * card.upsideDown.displayWidth) /
                5
          );
        }
        card.setData("showCardY", card.y);
        card.setData(
          "showCardX",
          i === 0
            ? card.x - card.displayWidth * 0.09
            : card.x + card.displayWidth * 0.09
        );
      }
      card.beforeWinY = card.getData("showCardY");
      card.beforeWinX = card.getData("showCardX");
    }
    this.cardsY = this.cardsList[0].y;
  }
}
